import React, { useState } from 'react';
import Icon, { IconType } from '../Icon/Icon';
import { store } from '../../redux/oldStore';
import { toast } from 'react-toastify';
import Editor from '../GenericForms/Editor';

interface EmailAPersonProps {
  personId: string;
  setModalOpen: (open: boolean) => void;
}

const EmailAPerson = (props: EmailAPersonProps) => {
  const [subject, setSubject] = useState('');
  const [editorState, setEditorState] = useState('');

  const onEditorStateChanged = (state) => {
    setEditorState(state);
  };


  const sendEmailClick = () => {
    let submitObj = {
      subject,
      message: editorState,
      personId: props.personId,
      //projectId?
    }
    store.server.postApi('../Email/SendEmailTo', submitObj).then(res => {
      toast.success('Email sent!');
      props.setModalOpen(false);
    })

  }

  return (
    <div className='form-horizontal'>

      <div className='form-group'>
        <label className='col-md-4 control-label'>Subject:</label>
        <div className='col-md-8'>
          <input
            className='form-control'
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>
      </div>
      <div className="head-room">
        <Editor value={editorState} options={'simple'} changed={onEditorStateChanged} height={'normal'}/>
      </div>
      <div>
        $NAME$ will be replaced with recipient's name.
        <br />
        $TITLE$ will be replaced with project's title.
        <br />
      </div>
      <div className='form-group'>
        <button
          className='btn btn-success'
          onClick={sendEmailClick}
        >
          <Icon type={IconType.paperPlane} /> Send
        </button>
        <button
          className='btn btn-default'
          onClick={() => props.setModalOpen(false)}
        >
          <Icon type={IconType.ban} /> Close
        </button>
      </div>
    </div>
  )
}

export default EmailAPerson